module.exports = __webpack_public_path__ + "static/images/components/VehicleFilter/images/favourite_vehicles.aca43318.png";


//////////////////
// WEBPACK FOOTER
// ./components/VehicleFilter/images/favourite_vehicles.png
// module id = 2702
// module chunks = 11